export default "__VITE_ASSET__CYAtG8$g__"